import { Button, Form, InputNumber, Select } from 'antd';
import { ArrowDown, ArrowUp, Trash2 } from 'lucide-react';
import type { RoleWithPermissions } from '../roles/roles.api';

interface TierRowProps {
  fieldName: number;
  isFirst: boolean;
  isLast: boolean;
  roleOptions: RoleWithPermissions[];
  onMoveUp: () => void;
  onMoveDown: () => void;
  onRemove: () => void;
}

/** One editable ladder rung: amount and approver role, plus reorder and remove — a form-editing convenience, since a saved ladder's order is always its amount order. */
export function TierRow({ fieldName, isFirst, isLast, roleOptions, onMoveUp, onMoveDown, onRemove }: TierRowProps) {
  return (
    <div className="flex items-end gap-2">
      <Form.Item
        className="mb-0 flex-1"
        name={[fieldName, 'amount']}
        label={isFirst ? 'Up to (KES)' : undefined}
        rules={[{ required: true, type: 'number', min: 1, message: 'Enter an amount' }]}
      >
        <InputNumber className="w-full" min={1} step={1000} />
      </Form.Item>
      <Form.Item
        className="mb-0 flex-1"
        name={[fieldName, 'roleKey']}
        label={isFirst ? 'Approver role' : undefined}
        rules={[{ required: true, message: 'Choose a role' }]}
      >
        <Select options={roleOptions.map((role) => ({ value: role.key, label: role.name }))} />
      </Form.Item>
      <Button aria-label="Move tier up" icon={<ArrowUp className="size-3.5" />} disabled={isFirst} onClick={onMoveUp} />
      <Button aria-label="Move tier down" icon={<ArrowDown className="size-3.5" />} disabled={isLast} onClick={onMoveDown} />
      <Button aria-label="Remove tier" danger icon={<Trash2 className="size-3.5" />} onClick={onRemove} />
    </div>
  );
}
